import React from "react";
import { Card } from "react-bootstrap";

import "./styles.css";

const CardHeader = (props) => {
  return <Card.Header className="c-header">{props.children}</Card.Header>;
};

export default CardHeader;
